import React from "react";
import { Remarkable } from "remarkable";

const markdown = new Remarkable();

const ExclusiveRate = ({ className = "", content = {} }) => {
  const { title, subtitle, price, description } = content;
  return (
    <div className={"exclusiveRate " + className}>
      <div className="description">
        <div className="logo">
          <img
            alt="exclusive rate logo"
            src="https://public.speedoc.com/design/images/speedoc.com/icons/crossCircle_v2.svg"
          />
        </div>
        <div className="text">
          <div>{title}</div>
          <span>{subtitle}</span>
        </div>
        <div className="showDetails">
          <img
            alt="exclusive rate show details"
            src="https://public.speedoc.com/design/images/speedoc.com/icons/threeDots.svg"
          />
        </div>
      </div>
      <div className="visual" />
      <div className="hoursAndPrice">
        <div className="left" dangerouslySetInnerHTML={{ __html: markdown.render(description) }} />
        <div className="right">{price}</div>
      </div>
    </div>
  );
};

export default ExclusiveRate;
